<div *ngIf="isLoading" class="loading-state">
  <mat-spinner [diameter]="42"></mat-spinner>
  <span>Loading</span>
</div>
<div *ngIf="events.length === 0 && !isLoading" class="no-event">No Events to show for this Application</div>
<div *ngIf="!isLoading && events.length > 0" class="app-search-flex">
  <div class="app-layout">
    <a (click) = "goToHome()" class="app"><mat-icon>arrow_back</mat-icon></a>
    <p class="app-text">{{appName}}</p>
  </div>

  <div>
    <button color="primary" mat-stroked-button (click)="OpenScheduleAllDialog()">
      <mat-icon>edit_notifications</mat-icon>
      Schedule All Notifications
    </button>&nbsp;&nbsp;
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>Search Event</mat-label>
      <input matInput placeholder="Search" (keyup)=searchEvent($event) [(ngModel)]="searchTerm">
      <mat-icon matSuffix *ngIf="searchTerm == ''">search</mat-icon>
      <mat-icon matSuffix class="cursor-pointer" *ngIf="searchTerm != ''" (click)="clearSearch()">clear</mat-icon>
    </mat-form-field>
  </div>
</div>

<!-- Side Nav Tab Div -->
<div *ngIf="!isLoading && events.length > 0" class="side-nav">
  <div class="tab">
    <p class="header">{{Headers.NotificationEngine.EventCategory}}</p>
    <div class="category">
      <div *ngFor="let category of categories; let i = index;trackBy: trackFunction" class="display-flex">
        <button title={{category.categoryName}} [ngClass]="{'tabActive':selectedCategory == category.categoryName}"
          class="tablinks" (click)="fetchEvents(category.categoryName)">{{category.categoryName}}
        </button>
        <span class="tab-span" [ngClass]="{'tabActive':selectedCategory == category.categoryName}"
          *ngIf="countedEvents.get(category.categoryName) > 0">{{countedEvents.get(category.categoryName)}}</span>
        <span class="tab-span" [ngClass]="{'tabActive':selectedCategory == category.categoryName}"></span>
      </div>
    </div>
  </div>

  <!-- Tab Content Header -->
  <div class="tabcontent">
    <div *ngIf="events.length == 0">
      No events to show
    </div>
    <!-- Table Div -->
    <div *ngIf="events.length > 0" class="notification-preference-table">
      <table mat-table [dataSource]="events" class="mat-elevation-z8">
        <!-- event name Column -->
        <ng-container matColumnDef="eventName" class="event-Column">
          <th mat-header-cell *matHeaderCellDef>{{Headers.NotificationEngine.Event}}</th>
          <td mat-cell *matCellDef="let event">
            <p class="align-description" [innerHTML]="event.eventDescription | highlightSearch: searchValue"></p>
          </td>
        </ng-container>

        <!-- email Column -->
        <ng-container matColumnDef="email" class="email-Column">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="primary" class="email-checkbox" [checked]="allComplete"
              [indeterminate]="isIndeterminate" (change)="setAll($event.checked)">
            </mat-checkbox>
            <span class="email-title">{{Headers.NotificationEngine.Email}}</span>
          </th>
          <td mat-cell *matCellDef="let event">
            <mat-checkbox color="primary" [checked]="event.email" [ngClass]="{'disabled':!event.canUserEdit}"
              [disabled]="!event.canUserEdit" class="email-checkbox" (change)="setEmailEvent(event)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- scheduling Column -->
        <ng-container matColumnDef="frequencyMode">
          <th mat-header-cell *matHeaderCellDef>{{Headers.NotificationEngine.EmailSchedule}}</th>
          <td mat-cell *matCellDef="let event">
            <tr *ngIf="event.email" class="display-frequencyModeFlex">
              <span>
                <button mat-icon-button color="primary" *ngIf="event.email" [ngClass]="{ 'cursor-pointer':event.canUserEdit}"
                [disabled]="!event.canUserEdit" aria-hidden="false" aria-label="scheduling"
                (click)="event.email && event.canUserEdit ? openDialog($event,event):''">
                  <mat-icon>edit</mat-icon>
                </button>
                &nbsp;
                <span *ngIf="event.frequencyMode == 'Weekly' && event.email">Every {{event.deliveryDay}}</span>
                <span *ngIf="event.frequencyMode != 'Weekly' && event.email">{{event.frequencyMode}}</span>
                <span *ngIf="event.frequencyMode != 'Immediate' && event.email">-
                  {{convertTo12Hour(event.frequencyTime)}}</span>
              </span>
              <span>
                <mat-icon color="primary" *ngIf="!event.canUserEdit" matTooltipClass="tooltip"
                  matTooltip={{Headers.NotificationEngine.DisabledEventsInfo}}>info</mat-icon>
              </span>
            </tr>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Tab Content Footer -->
    <div class="preference-footer">
      <button mat-stroked-button color="primary" [disabled]="disableSaveAndCancel"
        (click)="cancelChanges()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="disableSaveAndCancel" (click)="saveChanges()">Save Changes</button>
    </div>
  </div>
</div>